  const IdNoFilter = function (input) {
    if (input) {
      return input.substring(0, 3) + "***************" + input.substring(input.length - 4);
    }
  };
  let filterObj = {}
  filterObj.dimIdNo = IdNoFilter

  export default filterObj
